import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/react";
import { RxCross2 as XMarkIcon } from "react-icons/rx";
import { RxHamburgerMenu as Bars3Icon } from "react-icons/rx";
import Navdata from "./Navbardata";
import logoimage from "./vibecornerwhitelogo.png";
import { BsCartDash } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
// import { toggleStatusTab } from "../../stores/cart";
import { removeUser } from "../../stores/user";
import AuthService from "../../services/auth.service";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  // console.log(location);
  // const { hash, pathname, search } = location;
  const { hash, pathname } = location;

  const isActive = (iHash) => {
    if (iHash === "/#aboutus" && pathname === "/") {
      return true;
    }

    return pathname === iHash;
  };
  // console.log("Path:" + pathname);

  const currentUser = useSelector((store) => store.user);
  const [scrollPosition, setScrollPosition] = useState(0);

  const [totalQuantity, setTotalQuantity] = useState(0);
  const carts = useSelector((store) => store.cart.items);
  const dispatch = useDispatch();

  // const handleToggleCart = () => {
  //   navigate("/checkout");
  //   // dispatch(toggleStatusTab());
  // };

  const logOut = () => {
    AuthService.logout();
    dispatch(removeUser());
  };
  useEffect(() => {}, []);

  const handleScroll = () => {
    const position = window.scrollY;

    setScrollPosition(position);
  };

  const getHomepage = scrollPosition <= 20 && pathname === "/" ? true : false;
  // console.log(getHomepage)
  useEffect(() => {
    let total = 0;
    carts.forEach((item) => (total += item.quantity));
    setTotalQuantity(total);
    // console.log(total)

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollPosition, pathname, carts]);

  return (
    <Disclosure
      as="nav"
      className={`text-center list-none ${
        getHomepage
          ? `z-50 w-full fixed`
          : `z-50 w-full fixed bg-secondary transition ease-in-out delay-150`
      }`}
    >
      <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8 ">
        <div className="relative flex h-20 items-center justify-between">
          <div className="absolute inset-y-0 left-0 flex items-center md:hidden">
            {/* Mobile menu button*/}
            <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-white focus:outline-none">
              <span className="absolute -inset-0.5" />
              <span className="sr-only">Open main menu</span>
              <Bars3Icon
                aria-hidden="true"
                className="block size-6 group-data-[open]:hidden"
              />
              <XMarkIcon
                aria-hidden="true"
                className="hidden size-6 group-data-[open]:block"
              />
            </DisclosureButton>
          </div>

          <div className="flex flex-1 items-center justify-center sm:items-stretch md:justify-start">
            <div className="flex shrink-0 items-center">
              <a
                href="/#home"
                className="w-20"
              >
                <img
                  src={logoimage}
                  alt=""
                  className="object-cover"
                />
              </a>
            </div>
            <div className="hidden md:ml-6 md:block">
              <div className="flex pt-2.5 space-x-6 text-lg uppercase absolute   right-10 text-white">
                <>
                  {Navdata.map((item) => (
                    <HashLink
                      key={item.name}
                      style={{
                        color: "#fff",
                        fontWeight: "semi-bold",
                        paddingTop: "8px",
                        paddingBottom: "23px",
                        textTransform: "uppercase",
                        fontStretch: "expanded",
                      }}
                      to={item.pathname}
                      className={
                        isActive(`${item.pathname}`)
                          ? " text-yellow-300 border-b-4 border-yellow-300"
                          : "text-gray-300 hover:border-b-4 border-yellow-300 hover:text-yellow-300"
                      }
                      smooth={true}
                      duration={500}
                    >
                      {item.name}
                    </HashLink>
                  ))}
                  <div className="pt-2.5">
                    <a
                      className={classNames(
                        "bg-white rounded-full text-secondary pointer hover:bg-primary",
                        "px-6 py-3 uppercase"
                      )}
                      href="#contactus"
                    >
                      Contact Us
                    </a>
                  </div>
                </>
              </div>
            </div>
          </div>

          {/* Shopping Cart Icon and number */}
          {/* <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
            <div className="flex justify-between items-center ">
              <button onClick={handleToggleCart}>
                <div className="w-7 h-7 bg-gray-100 rounded-full flex justify-center items-center relative ">
                  <BsCartDash className="w-4" />
                  <span
                    className=" absolute top-2/3 right-1/2
bg-red-500 text-white text-sm
w-5 h-5 rounded-full flex justify-center items-center"
                  >
                    {totalQuantity}
                  </span>
                </div>
              </button>
            </div>
          </div> */}

          {/* Profile dropdown */}
          {currentUser.token ? (
            <Menu
              as="div"
              className="relative ml-3"
            >
              <div>
                <MenuButton className="relative flex rounded-full bg-gray-800 text-sm focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800 focus:outline-hidden">
                  <span className="absolute -inset-1.5" />
                  <span className="sr-only">Open user menu</span>
                  <img
                    alt=""
                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    className="size-8 rounded-full"
                  />
                </MenuButton>
              </div>
              <MenuItems
                transition
                className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 ring-1 shadow-lg ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
              >
                <MenuItem>
                  {currentUser.role === "admin" ? (
                    <p></p>
                  ) : (
                    <p>
                      <Link
                        to="/profile"
                        className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden"
                      >
                        Profile
                      </Link>
                    </p>
                  )}
                </MenuItem>
                <MenuItem>
                  <Link
                    to={
                      currentUser.role === "admin"
                        ? "admin/dashboard"
                        : "/dashboard"
                    }
                    className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden"
                  >
                    {currentUser.role === "admin" ? (
                      <p>Admin Dashboard</p>
                    ) : (
                      <p>Dashboard</p>
                    )}
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link
                    onClick={logOut}
                    className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden"
                  >
                    Sign out
                  </Link>
                </MenuItem>
              </MenuItems>
            </Menu>
          ) : (
            ""
          )}
        </div>
        {/* <CartTab /> */}
      </div>

      <DisclosurePanel className="md:hidden">
        <div className="grid row space-y-1 px-2 pb-3 pt-2 uppercase">
          <>
            {Navdata.map((item) => (
              // <DisclosureButton
              //   key={item.name}
              //   as="a"
              //   href={item.link}
              //   aria-current={item.current ? "page" : undefined}
              //   className={classNames(
              //     item.current
              //       ? "bg-gray-900 text-white"
              //       : "text-gray-300 hover:bg-gray-700 hover:text-white",
              //     "block rounded-md px-3 py-2 text-base font-medium"
              //   )}
              // >
              //   {item.name}
              // </DisclosureButton>
              <div
                className="m-auto p-3"
                key={item.name}
              >
                <HashLink
                  style={{
                    color: "#fff",
                    fontWeight: "semi-bold",
                    paddingTop: "8px",
                    paddingBottom: "5px",
                    textTransform: "uppercase",
                    fontStretch: "expanded",
                  }}
                  to={item.pathname}
                  className={
                    isActive(`${item.pathname}`)
                      ? " text-yellow-300 border-b-4 border-yellow-300"
                      : "text-gray-300 hover:border-b-4 border-yellow-300 hover:text-yellow-300"
                  }
                  smooth={true}
                  duration={500}
                >
                  {item.name}
                </HashLink>
              </div>
            ))}

            <div className="p-5">
              <a
                className={classNames(
                  "bg-white rounded-full text-secondary pointer hover:bg-primary",
                  "px-6 py-3 uppercase"
                )}
                href="#contactus"
              >
                Contact Us
              </a>
            </div>
          </>
        </div>
      </DisclosurePanel>
    </Disclosure>
  );
}

export default Navbar;
